module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNSAxNSIgd2lkdGg9IjgwMCIgaGVpZ2h0PSI0ODAiPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0wIDBoMjV2MTVIMHoiLz48ZyBmaWxsPSIjQ0UxMTI0Ij48cGF0aCBkPSJNMTEgMGgzdjE1aC0zeiIvPjxwYXRoIGQ9Ik0wIDZoMjV2M0gweiIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/eng.svg
// module id = j4jj
// module chunks = 0